import { Typography } from "@mui/material";
import { Colors } from "../../../../styles/theme";
import { useLanguage } from "../../../../context/LanguageContext";
import styles from "./Promotion.styles";

const Promotion = () => {
  const { translate } = useLanguage();

  return (
    <div className="section" style={styles.Promotion_container}>
      <Typography
        variant="h6"
        component="p"
        fontWeight={600}
        color={Colors.white}
        sx={{
          lineHeight: 1.65,
          textAlign: "center",
        }}
      >
        {translate("promotion header2")}
      </Typography>
    </div>
  );
}
export default Promotion;
